/*  MUI  */
import { Grid } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';

/*  React  */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/* Internal Components */
import { AdminUsersAccountsCards } from './internal/AdminUsersAccountsCards';
import { AdminUsersAccountsTable } from './internal/AdminUsersAccountsTable';

export const AdminUsersAccounts = () => {
    const { t } = useTranslation();
    const [data, setData] = useState(null);

    return (
        <>
            <PageTitle title={t('Common.accounts')} />
            <Grid container spacing={3} data-testid="adminUsersAccounts">
                <AdminUsersAccountsCards data={data} />
                <Grid item xs={12}>
                    <AdminUsersAccountsTable setData={setData} />
                </Grid>
            </Grid>
        </>
    );
};
